module.exports = __webpack_public_path__ + "static/media/in-number-0.ce55711f.png";